var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLivingroombig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21.453pt",
    height: "20.398pt",
    viewBox: "0 0 21.453 20.398",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.727 20.09 0.14844 0.20313 10.578-7.6836-4.0976-12.609h-13.258l-4.0977 12.609 10.727 7.7891 0.14844-0.10546-0.14844-0.20313 0.14844-0.19922-10.285-7.4726 3.8711-11.918h12.531l3.8711 11.918-10.285 7.4726 0.14844 0.19922 0.14844-0.19922",
    fill: "#231f20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivingroombig);
export default __webpack_public_path__ + "static/media/livingroombig.157774ffd651630e0e037ad71edaddf2.svg";
export { ForwardRef as ReactComponent };